import { useMatchScreen } from '../context/MatchScreenContext'

export type AdTier = 'under25' | 'under100K'

/**
 * Selects the ad tier to render based on the user's current savings band.
 * Returns `null` when savings fall outside a band that shows ads, in which
 * case the caller should render nothing.
 *
 * @param adTier optional override for the under-25k band (defaults to 'under25')
 */
export const useAdTier = (adTier?: AdTier): AdTier | null => {
  const { state } = useMatchScreen()
  const currentSavings = state?.currentSavings

  if (currentSavings === '(min, 25000)') {
    return adTier || 'under25'
  }

  if (currentSavings === '[25000, 100000)') {
    return 'under100K'
  }

  return null
}
